<template>
    <header class="header">
      <h2 class="site-title-in">MULLI</h2><h2 class="site-title-the">G</h2><h2 class="site-title-stands">UESS</h2>
    </header>
</template>

<script></script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 28px;
  padding-bottom: 8px;
  background-color: var(--color-bg);
  border-bottom: var(--color-bg);
}

.site-title-in {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-main-info-terceary);
  font-family: 'Poppins', sans-serif;
  letter-spacing: 1.5px;
}

.site-title-the {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-main-info-secondary);
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.5px;
}

.site-title-stands {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-main-info);
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.5px;
}

</style>